<script>
export default {
  name: 'NewsList'
}
</script>

<script setup>

import {onMounted, reactive, ref} from "vue";
import axios from "axios";
import { url } from '@/config/urls';
import router from "@/router/index.js";
import Pagination from "@parts/Pagination.vue";

const props = defineProps({
  isAuthenticated: Boolean,
  listApiUrl: {
    type: String,
    default: url.api.news.list,
  },
  actionHistoryApiUrl: {
    type: String,
    default: url.api.actionHistory,
  },
  detailUrl: {
    type: String,
    default: url.page.news.detail,
  },
  loginUrl: {
    type: String,
    default: url.login
  },
  error: {
    type: String,
    default: url.error
  }
});

// ページネーション
const pagingParameter = reactive({
  pageNum: 1,
  pageSize: 20
});
const totalPage = ref(1);
const totalNum = ref(0);
const hasNext = ref(false);

// 検索結果
const newsList = ref([])

// 検索条件
const condition = reactive({
  page: '',
  size: ''
});

const newsApiCompleted = ref(false);

// ページネーション処理
// ページネーション表示件数変更時
const changePageNum = (page) => {
  if (!Number.isFinite(page)) {
    return;
  }
  condition.page = page;
  getNewsList();

  pagingParameter.pageNum = page;
}

// ページネーション表示件数変更時
const onChangePageSize = (value) => {
  condition.page = 1;
  condition.size = value;
  getNewsList();

  pagingParameter.pageNum = 1;
  pagingParameter.pageSize = value;
}

// 検索条件のセット
const setCondition = () => {
  condition.page = pagingParameter.pageNum;
  condition.size = pagingParameter.pageSize;
}

/**
 * お知らせ一覧の取得
 *
 * 401: login画面に遷移
 * 400,404: 表示お知らせ0件パターンと同じ
 */
const getNewsList = () => {
  axios.get(props.listApiUrl, {params: condition})
   .then((response) => {
     newsList.value = response.data.response.news;
     totalPage.value = Math.ceil(response.data.response.totalNum / pagingParameter.pageSize);
     totalNum.value = response.data.response.totalNum;
     hasNext.value = response.data.response.hasNext;
   })
   .catch((error) => {
     switch (error?.response?.status) {
       case 401:
         router.replace(props.loginUrl);
         break;
       case 400:
       case 404:
         newsList.value = [];
         pagingParameter.pageNum = 1;
         totalPage.value = 1;
         totalNum.value = 0;
         hasNext.value = false;
         break;
       default:
         break;
     }
   })
  .finally(() => newsApiCompleted.value = true);
}

/**
 * ログの保存完了後、指定お知らせ詳細画面に遷移
 *
 * 400,500: 汎用エラー画面に遷移
 * 401: ログイン画面に遷移
 *
 * @param id お知らせID
 * @param title お知らせタイトル
 * @returns {Promise<void>}
 */
const handleLinkClick = async(id, title) => {
  const param = {
    logType: 'news',
    targetLogId: id,
    body: title
  };

  try {
    await axios.post(props.actionHistoryApiUrl, param);

    // 詳細画面に遷移
    router.push(`/news/${id}`)
  }catch(error) {
    const status = error?.response?.status;
    switch (status) {
      case 400:
        sessionStorage.setItem('errorHeading', '指定されたページを表示できません。');
        sessionStorage.setItem('errorBody', '申し訳ございませんが、リクエストを正しく処理できませんでした。送信内容が正確であることを確認し、もう一度お試しください。');
        router.push(props.error);
        break;
      case 401:
        router.push(props.loginUrl);
        break;
      case 500:
        sessionStorage.setItem('errorHeading', 'サーバーエラー。');
        sessionStorage.setItem('errorBody', 'サーバーで問題が発生しました。現在、サービス提供ができない可能性があります。しばらくしてから再度アクセスしてください。');
        router.push(props.error);
        break;
      default:
        break;
    }
  }
}

onMounted(() => {
  setCondition();
  getNewsList();
});

</script>

<template>
  <div id="contents1">

    <div class="com_inner2">

      <div class="com_br_cnt1 stl1">

        <h2 class="com_title2 com_mgb30 com_mgb25s">お知らせ</h2>

        <p class="com_center1" v-if="newsApiCompleted && newsList.length === 0">現在お知らせはありません。</p>
        <div v-else>
          <pagination
            :isShowFirstAndLastBtn='true'
            :isShowPaginationInfo='false'
            :currentPage='pagingParameter.pageNum'
            :totalPage='totalPage'
            :pageSize='pagingParameter.pageSize'
            :hasNext='hasNext'
            :pageSizeSelectList='[10, 20, 30, 50, 100]'
            @changePageNum='changePageNum'
            @changePageSize='onChangePageSize'
          ></pagination>

          <table class="com_d_list1">
            <tbody>
            <tr v-for="news in newsList">
              <th><span>{{ news.notificationDate }}</span>
                <div class="com_tags1">
                  <span v-if="news.newFlg" class="tag1">NEW</span>
                  <span v-if="news.importance === '1'" class="tag2">重要</span>
                </div>
              </th>
              <td><a @click="handleLinkClick(news.id, news.title)" href="#!">{{ news.title }}</a></td>
            </tr>
            </tbody>
          </table>

          <pagination
            :isShowFirstAndLastBtn='true'
            :isShowPaginationInfo='false'
            :currentPage='pagingParameter.pageNum'
            :totalPage='totalPage'
            :pageSize='pagingParameter.pageSize'
            :hasNext='hasNext'
            :pageSizeSelectList='[10, 20, 30, 50, 100]'
            @changePageNum='changePageNum'
            @changePageSize='onChangePageSize'
          ></pagination>

        </div>

      </div>

    </div>

  </div>

</template>

<style scoped>

</style>
